// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apihost: 'https://guinea-tas-server.revenuedev.org/web',
  apihostDomain : 'https://guinea-tas-server.revenuedev.org',
  authServerhost: 'https://sso.revenuedev.org/?returnUrl=https://guinea-govin.revenuedev.org',
  authServerhostLogout: 'https://sso.revenuedev.org/logout?returnUrl=https://guinea-govin.revenuedev.org',
  whitelistDomain: "guinea-tas-server.revenuedev.org",
  blacklistDomain: "guinea-tas-server.revenuedev.org/web/auth"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
